import React from 'react';
import framework from 'utils/framework';
const { wrapFunctionalComponent } = framework;
import NthCategoryPage from 'components/Category/NthCategoryPage';

const NthCategory = () => {
    return (
        <div>
            <NthCategoryPage />
        </div>
    );
};

export default wrapFunctionalComponent(NthCategory, 'NthCategory');
